"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TILE_TYPES = exports.TEXT_ALIGN = exports.NO_MARGIN = exports.MOBILE_IMAGE_CONSTANTS = exports.MAX_WIDTH_MOBILE = exports.MAX_WIDTH_DESKTOP = exports.LABEL_TEXT_LIMIT = exports.LABEL_TEXT_COLOR = exports.LABEL_COLOR = exports.ICON_FONT_SIZE = exports.DESKTOP_IMAGE_CONSTANTS = exports.ARROW_TYPE = exports.ANIMATION_TYPE = void 0;
var DESKTOP_IMAGE_CONSTANTS = {
  HEIGHT: '32px',
  WIDTH: '32px'
}; // export const MOBILE_IMAGE_CONSTANTS = {
// };

exports.DESKTOP_IMAGE_CONSTANTS = DESKTOP_IMAGE_CONSTANTS;
var MOBILE_IMAGE_CONSTANTS = {
  PRODUCT_TILE: {
    HEIGHT: '50px',
    WIDTH: '50px',
    MOBILE_CONTAINER_FLEX: 'none'
  },
  BOTTOM_TILE: {
    HEIGHT: '24px',
    WIDTH: '24px',
    NONE: 'none',
    MOBILE_CONTAINER_FLEX: 1
  }
};
exports.MOBILE_IMAGE_CONSTANTS = MOBILE_IMAGE_CONSTANTS;
var NO_MARGIN = '0px';
exports.NO_MARGIN = NO_MARGIN;
var MAX_WIDTH_DESKTOP = '120px';
exports.MAX_WIDTH_DESKTOP = MAX_WIDTH_DESKTOP;
var MAX_WIDTH_MOBILE = '70px';
exports.MAX_WIDTH_MOBILE = MAX_WIDTH_MOBILE;
var ARROW_TYPE = 'ChevronRightIcon';
exports.ARROW_TYPE = ARROW_TYPE;
var ICON_FONT_SIZE = 'titleNormal';
exports.ICON_FONT_SIZE = ICON_FONT_SIZE;
var TEXT_ALIGN = 'center';
exports.TEXT_ALIGN = TEXT_ALIGN;
var ANIMATION_TYPE = {
  noAnimation: 'noAnimation',
  LTR: 'LTR',
  RTL: 'RTL'
};
exports.ANIMATION_TYPE = ANIMATION_TYPE;
var TILE_TYPES = {
  PRODUCT_TILE: 'PRODUCT_TILE',
  BOTTOM_TILE: 'BOTTOM_TILE'
};
exports.TILE_TYPES = TILE_TYPES;
var LABEL_TEXT_COLOR = 'primaryDark';
exports.LABEL_TEXT_COLOR = LABEL_TEXT_COLOR;
var LABEL_COLOR = 'primaryLight';
exports.LABEL_COLOR = LABEL_COLOR;
var LABEL_TEXT_LIMIT = 10;
exports.LABEL_TEXT_LIMIT = LABEL_TEXT_LIMIT;